import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { AuthShell, AuthError, AuthSuccess } from '../components/auth/AuthShell';
import { useI18n } from '../contexts/I18nContext';
import * as authApi from '../lib/authApi';

export function ForgotPasswordPage() {
  const { t } = useI18n();

  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await authApi.forgotPassword(email);
      // The backend always answers 200 (no account enumeration), so success
      // here just means "request accepted".
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('auth.reset.failed'));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell title={t('auth.forgot.title')}>
      {sent ? (
        <AuthSuccess message={t('auth.forgot.success')} />
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <p className="text-sm" style={{ color: '#94A3B8' }}>
            {t('auth.forgot.subtitle')}
          </p>

          {error && <AuthError message={error} />}

          <label className="block text-sm">
            <span style={{ color: '#94A3B8' }}>{t('login.email')}</span>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-field mt-1 w-full px-3 py-2 outline-none"
            />
          </label>

          <button
            type="submit"
            disabled={submitting}
            className="login-submit w-full px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-50"
          >
            {submitting ? t('auth.forgot.submitting') : t('auth.forgot.submit')}
          </button>
        </form>
      )}

      <p className="text-center text-sm" style={{ color: '#64748B' }}>
        <Link to="/login" style={{ color: '#A78BFA' }} className="underline">
          {t('auth.forgot.backToLogin')}
        </Link>
      </p>
    </AuthShell>
  );
}
